import i18next from 'i18next';

import translations_de from "./../i18n/de.json"

i18next.init({
    lng: 'de', // if you're using a language detector, do not define the lng option
    debug: false,
    resources: {
      de: {
        translation: translations_de
      }
    }
  });

export default i18next;